import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../services/api/client';

export interface ApprovalCounts {
  managerTimesheets?: number;
  managerExpenses?: number;
  managerTimeOffs?: number;
  adminTimesheets?: number;
  adminJoinRequests?: number;
  // Phase 113 (MKS-208, D-11) — pending backdated-hours requests. No email and
  // no Slack in v1; this count is the whole notification.
  adminBackdatedRequests?: number;
}

async function getApprovalCounts(): Promise<ApprovalCounts> {
  const res = await apiGet<{ data: ApprovalCounts }>('/approval-counts');
  return res.data;
}

export function useApprovalCounts(enabled: boolean) {
  return useQuery({
    queryKey: ['approvalCounts'],
    queryFn: getApprovalCounts,
    enabled,
    refetchInterval: 60_000,
    // The badge can otherwise freeze at a phantom value: the 60s interval is
    // paused while the tab is backgrounded, the global default disables
    // refetchOnWindowFocus, and the ['approvalCounts'] cache is only
    // invalidated by the *acting* user's own approve/decline — so when a
    // different admin/PM resolves the items, this user's count goes stale.
    // Treat the count as always-stale and refetch whenever the tab regains
    // focus so returning to it recomputes the badge from the DB.
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
